module.exports = __webpack_public_path__ + "img/signup.f14652bd.svg";